<div class="bg">
  <div class="d-flex flex-column">
    <span class="d-flex flex-row justify-content-between text-1430" style="color: white;">
      {{'g.openapp.title'|translate}}</span>
  </div>
  <div class="d-flex flex-row justify-content-end">
    <button mat-button (click)="Back(false)" style="color: #2980b9;"> <span
        class="pl-1 ke-font-button">{{'g.openapp.no'|translate}}</span></button>

    <button mat-button (click)="Back(true)" style="color: #2980b9;"> <span
        class="pl-1 ke-font-button">{{'g.openapp.yes'|translate}}</span></button>
  </div>
</div>
